import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import GenericDropdown from "@ui-components/Dropdown/GenericDropdown";
import { SyslogItem } from "./request/request";

export const LOG_LEVELS = [
    "Emergency",
    "Alert",
    "Critical",
    "Error",
    "Warning",
    "Notice",
    "Informational",
    "Debug",
];

/** 
 * Columnas para la tabla de "Available" 
 * Muestran un checkbox "Select", IP y Name
 */
export function getAvailableColumns(
    selectedIds: Set<number>,
    onToggleRow: (id: number) => void
): GenericTableColumn<SyslogItem>[] {
    return [
        {
            header: "Select",
            renderCell: (row: SyslogItem) => (
                <input
                    type="checkbox"
                    checked={selectedIds.has(row.id)}
                    onChange={() => onToggleRow(row.id)}
                />
            ),
        },
        {
            header: "IP",
            accessor: "ip",
        },
        {
            header: "Name",
            // Podrías usar accessor: "description"
            accessor: "description",
        },
    ];
}

/** 
 * Columnas para la tabla de "Selected" 
 * Igual, más la columna "Level" con un dropdown
 */
export function getSelectedColumns(
    selectedIds: Set<number>,
    onToggleRow: (id: number) => void,
    onLevelChange: (row: SyslogItem, newLevelStr: string) => void
): GenericTableColumn<SyslogItem>[] {
    return [
        {
            header: "Select",
            renderCell: (row: SyslogItem) => (
                <input
                    type="checkbox"
                    checked={selectedIds.has(row.id)}
                    onChange={() => onToggleRow(row.id)}
                />
            ),
        },
        {
            header: "IP",
            accessor: "ip",
        },
        {
            header: "Name",
            accessor: "description",
        },
        {
            header: "Level",
            renderCell: (row: SyslogItem) => {
                // Si row.level es 0 => "Emergency"; si 3 => "Error", etc.
                const currentLevelStr =
                    row.level !== undefined ? LOG_LEVELS[row.level] : LOG_LEVELS[0];

                return (
                    <GenericDropdown
                        items={LOG_LEVELS}
                        value={currentLevelStr}
                        onSelect={(newVal) => onLevelChange(row, newVal)}
                        widthClass="w-[140px]"
                        fixedPosition={true}
                        dropdownMaxHeightClass="max-h-48"
                        size="sm"
                    />
                );
            },
        },
    ];
}
